import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './app-header.css'
import { UserContext } from '../../UserContext';
import axios from "axios";
import api from "../../api";
import LanguageDropDown from "../languageDropDown/dropDown";
import translations from "../../translations";
import { LanguageContext } from "../../languageContext";
import Modal from 'react-bootstrap/Modal';
import ProfileSetting from "../profileSetting/profileSetting";
import ResetPassword from "../reset-password/reset-password";

const pages = ['Dashboard'];
const settings = ['Profile', 'Logout'];


function CustomModal(props) {
    return (
        <Modal
            show={props.show} onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <img className="cross-close-btn" src="./cross.svg" alt="close-btn" onClick={props.onHide} />
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.translate("Review User Profile")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProfileSetting />
            </Modal.Body>
        </Modal>
    );
}

function ResetPasswordModal(props) {
    return (
        <Modal
            show={props.show} onHide={props.onHide}
            size="lg-6"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header>
                {/*<img className="cross-close-btn" src="./cross.svg" alt="close-btn" onClick={props.onHide} />*/}
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.translate("Please reset your password.")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ResetPassword hide = {props.onHide} translate = {props.translate} />
            </Modal.Body>
        </Modal>
    );
}

function AppHeader() {
    const { setUser } = useContext(UserContext); // Access the context
    const { isTraining } = useContext(UserContext); // Access the context
    const navigate = useNavigate();
    const location = useLocation();
    const [currentUrl, setCurrentUrl] = useState('');
    const { language } = useContext(LanguageContext);
    const SERVER_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:3000/api/v1/"
        : "/api/v1/";

    const [langOpt, setLangOpt] = useState(sessionStorage.getItem('langOpt') || 'Japanese');
    const [profileModalShow, setProfileModalShow] = React.useState(false);
    const [resetPasswordModalShow, setResetPasswordModalShow] = React.useState(false);

    useEffect(() => {
        postUserData();
    }, []);

    useEffect(() => {
        setCurrentUrl(location.pathname);
    }, [location]);

    const handleNavigation = (page) => {
        navigate(`/${page.toLowerCase()}`); // Adjust this to your routing logic
    };
    const handleDropDown = async (dropDown) => {
        if (dropDown === "Logout") {
            const token = sessionStorage.getItem("token");
            if (token) {
                try {
                    await api.post("auth/logout", {},{ withCredentials: true });
                } catch (err) {
                    console.warn("Logout API failed:", err);
                }
            }
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = `/oauth2/sign_out?rd=${encodeURIComponent('/login')}`;
        }
        if (dropDown === "Profile") {
            setProfileModalShow(true) // Adjust this to your routing logic
        }
    };

    useEffect(() => {
        setLangOpt(language);
    }, [language])

    const translate = (text) => {
        if (text) {
            return langOpt === 'Japanese' ? translations[text] : text;
        } else {
            return text
        }
    };

    const postUserData = async () => {
        try {
            if(sessionStorage.getItem('token')){
                debugger
                const response = await api.get(`user/user-Details`);
                // Store response in context and sessionStorage
                setUser(response.data.data);
                if(!response.data.data.resetPassword){
                    setResetPasswordModalShow(true);
                }
            }else{
                const userData = await axios.get("/oauth2/userinfo",{headers: {
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Expires': '0'
                }})
                if (userData?.data?.preferredUsername){
                const response = await api.post(`user`, {
                    userEmail: userData.data.preferredUsername,
                    firstName: '',
                    lastName: '',
                    nativeLanguage:'en'
                });
                setUser(response.data.data);
                }
            }
        } catch (err) {
            console.error('Error:', err);
        } finally {
        }
    };


    return (
        <>
            <Navbar expand="lg" className={isTraining ? "disabled bg-body-tertiary custom-nav" : "bg-body-tertiary custom-nav"}>
                <Container>
                    <Navbar.Brand><img src="./fuso-logo.svg" className="company-logo-header" alt="company-logo" /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" >
                        <Nav className="me-auto custom-nav-items">
                            {pages.map((page) => (
                                <div className={currentUrl === `/${page.toLowerCase()}` ? "custom-nav-item selectedMenu" : "custom-nav-item"} key={page} onClick={() => handleNavigation(page)} >{translate(`${page}`)}</div>
                            ))}
                        </Nav>
                        {/*<LanguageDropDown />*/}
                        {window.innerWidth >= 991 ? (
                        <NavDropdown
                            title={<img src="./default-profile-pic.png" alt="dropdown-icon" style={{ width: "30px", height: "30px", cursor: "pointer" }} />}
                            id="basic-nav-dropdown">
                            {settings.map((setting) => (
                                <NavDropdown.Item key={setting} onClick={() => { handleDropDown(setting) }}>{translate(setting)}</NavDropdown.Item>
                            ))}
                        </NavDropdown>):(settings.map((setting) => (
                            <div
                                className="dropdown-item custom-nav-item"
                                key={setting}
                                onClick={() => handleDropDown(setting)}
                            >
                                <span className="setting-text">{translate(setting)}</span>
                            </div>
                        )))}
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <CustomModal show={profileModalShow}
                translate={translate}
                onHide={() => { setProfileModalShow(false) }}
            />
            <ResetPasswordModal show={resetPasswordModalShow}
                translate={translate}
                onHide={() => { setResetPasswordModalShow(false) }}
            />
        </>
    );
}
export default AppHeader;
